import { useSuspenseQuery } from '@tanstack/react-query'

import { GetProdutosService } from '@/features/produtos/services/get-produtos.service'
import { produtosKeys } from '@/features/produtos/utils'
import type { TUnidadeTipoEnum } from '@/shared/interfaces/produto.enums'

export const useSuspenseProdutos = (idExternoBloco: number, tipoProduto: TUnidadeTipoEnum, isVagaPadrao?: boolean) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.lista({ idExternoBloco, tipoProduto, isVagaPadrao }),
    queryFn: () =>
      new GetProdutosService().execute(idExternoBloco, tipoProduto, isVagaPadrao).then((response) => response.data),
  })
}
